// extracted by mini-css-extract-plugin
export default {"flexBoxBlk":"ProfileNav_flexBoxBlk__4UqB0"};